import script from "./ProductTourOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductTourOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./ProductTourOverlay.vue?vue&type=style&index=0&id=48164746&lang=scss&scoped=true"
import "./ProductTourOverlay.vue?vue&type=style&index=1&id=48164746&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48164746"]])

export default __exports__